const theme = {
    colors: {
      primary: "#3f48cc",
      secundary: "#7e7bec",
      shape: "#fafcfd",
      fild: "#eeeefd",
      text: "#818191",
      title: "#101d42",
      yellow: "#ffc60b",
    },
    fonts: {
      extraTitle: 48,
      title: 24,
      subTitle: 18,
      text: 14,
      subText: 12,
    },
  };
  
  export default theme;
  